// Authentication tracking store module
const STORAGE_KEY = "auth_tracking";

const state = () => ({
  authVersion: "unauthenticated",
  authMethod: "unauthenticated"
});

const mutations = {
  setAuth(state, { authVersion, authMethod }) {
    state.authVersion = authVersion;
    state.authMethod = authMethod;
  },
  resetAuth(state) {
    state.authVersion = "unauthenticated";
    state.authMethod = "unauthenticated";
  }
};

const actions = {
  trackAuthInit({ commit }) {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const { authVersion, authMethod } = JSON.parse(stored);
        // Only set if values are valid
        if (authVersion && authMethod) {
          commit("setAuth", { authVersion, authMethod });
          // Note: No need to set gtag here as App.vue watchers will handle it
        }
      }
    } catch (error) {
      // If any error occurs during initialization, ensure we're in unauthenticated state
      commit("resetAuth");
      localStorage.removeItem(STORAGE_KEY);
    }
  },
  
  trackAuthStart({ commit }, { version, method }) {
    // Validate version and method
    const validVersions = ["V1", "V2"];
    const validMethods = ["password", "google", "facebook"];
    
    const finalVersion = validVersions.includes(version) ? version : "V1";
    const finalMethod = validMethods.includes(method) ? method : "password";

    commit("setAuth", { 
      authVersion: finalVersion, 
      authMethod: finalMethod 
    });
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      authVersion: finalVersion,
      authMethod: finalMethod
    }));

    // Track authentication start
    window.gtag?.("event", "authenticated_begin", {
      auth_version: finalVersion,
      auth_method: finalMethod
    });
  },
  
  trackAuthEnd({ state, commit }) {
    // Track authentication end with current state
    window.gtag?.("event", "authenticated_ended", {
      auth_version: state.authVersion,
      auth_method: state.authMethod
    });
    
    // Reset to unauthenticated state
    commit("resetAuth");
    
    // Clear local storage
    localStorage.removeItem(STORAGE_KEY);
    
    // Note: No need to set gtag here as App.vue watchers will handle it
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
